export enum UserEntityProfileType {
    USER = 0,
    ENS_MANAGER = 1,
    SERVICE_MANAGER = 2,
    SIGNER = 3,
    SUPPORT = 4,
    AOC_MANAGER = 5,
    ADMIN = 6,
    BATCH_MANAGER = 7,
    APP_SPEC_MANAGER = 9,
}
